export default __webpack_public_path__ + "static/media/76.6fdcc695.jpg";